// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pi-1";
export var messageSideRight = "_pi-2";
export var orderLookupBubbleContainer = "_pi-0";
export var submitButton = "_pi-3";